import type { MoverItem } from '../types';

const getMockMovers = (): MoverItem[] => [
    {
        id: 'mov_initech',
        name: 'Initech',
        deltaLabel: '-$215 margin',
        tone: 'negative',
    },
    {
        id: 'mov_acme',
        name: 'Acme Corp',
        deltaLabel: '+$188 margin',
        tone: 'positive',
    },
    {
        id: 'mov_northwind',
        name: 'Northwind Labs',
        deltaLabel: '+$96 margin',
        tone: 'positive',
    },
    {
        id: 'mov_globex',
        name: 'Globex',
        deltaLabel: '-$64 (no payment)',
        tone: 'negative',
    },
];

export default getMockMovers;
